import { combineReducers } from 'redux';

// *** GQ-ADMIN ***
import {
    gqAdminAuthReducers,
    gqAdminPaymentPagesReducers,
    gqAdminFormEditorReducers,
    gqAdminStudentsReducers,
    gqAdminGileClassesReducers,
} from './reducers/gq-admin';
const gqAdminReducersObj = {
    ...gqAdminAuthReducers,
    ...gqAdminPaymentPagesReducers,
    ...gqAdminFormEditorReducers,
    ...gqAdminStudentsReducers,
    ...gqAdminGileClassesReducers,
};

// *** GQ-CUSTOMER ***
import {
    gqCustomerProfileReducers,
    gqCustomerMobileAuthReducers
} from './reducers/gq-customer';
const gqCustomerReducersObj = {
    ...gqCustomerProfileReducers,
    ...gqCustomerMobileAuthReducers,
};

// *** GQ-NOTIFY *** 
import { 
    notifyAuthReducers, 
    notifyMobileOtpReducers 
} from './reducers/gq-notification';
const gqNotifyReducersObj = {
    ...notifyAuthReducers,
    ...notifyMobileOtpReducers,
};

// *** GQ-SVC_PP ***
import { 
    gqSvcPpMiscReducers,
    gqSvcPpEmailReducers,
} from './reducers/gq-svc-pp';
const gqSvcPpReducersObj = {
    ...gqSvcPpMiscReducers,
    ...gqSvcPpEmailReducers,
};

// *** ALL SERVICES ***
const rootReducer = combineReducers({
    ...gqAdminReducersObj,
    ...gqCustomerReducersObj,
    ...gqNotifyReducersObj,
    ...gqSvcPpReducersObj,
});

export default rootReducer;
